import { render, staticRenderFns } from "./AlternativeCalculationSettingsTable.vue?vue&type=template&id=2d86bbc3&scoped=true"
import script from "./AlternativeCalculationSettingsTable.vue?vue&type=script&lang=ts"
export * from "./AlternativeCalculationSettingsTable.vue?vue&type=script&lang=ts"
import style0 from "./AlternativeCalculationSettingsTable.vue?vue&type=style&index=0&id=2d86bbc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d86bbc3",
  null
  
)

export default component.exports